<template>
	<div>
		<!-- 啥东西能根据一张图片给我生成代码 -->
		<div style="display: flex; padding: 10px">
			<div style="width: calc(100vw - 600px); height: 220px; display: flex; flex-wrap: wrap">
				<a-card
					v-for="(d, index) in dataList.obj"
					:key="index"
					style="margin-bottom: 10px; width: 30%; margin-right: 10px"
					hoverable
					@click.stop="gotoEvent(d)"
					:body-style="{ padding: '10px' }"
				>
					<template #extra>
						<a-button type="text">
							<CloseOutlined @click.stop="closeEvent(d, 0)" v-if="d.show_on_mobile" />
							<EyeOutlined @click.stop="showEvent(d, 1)" v-else />
						</a-button>
					</template>
					<template #title>
						<span :style="{ color: d.huiyi_status == -1 ? 'var(--grey-color-100)' : 'var(--my-primary-color)' }">{{ d.会议名称 }}</span>
					</template>
					<div style="display: flex">
						<div style="margin-right: 10px">
							<a-image
								width="120px"
								height="120px"
								:style="{
									filter: d.huiyi_status == -1 ? 'grayscale(100%)' : ''
								}"
								:src="d.会议图片 ? d.会议图片 : defaultImg"
							/>
						</div>
						<div>
							<a-tag color="#2db7f5" v-if="d.huiyi_status == 1">
								<template #icon>
									<MoneyCollectOutlined />
								</template>
								进行中
							</a-tag>
							<a-tag color="#caf5c7" v-else-if="d.huiyi_status == 0">
								<template #icon>
									<MoneyCollectOutlined />
								</template>
								未开始
							</a-tag>

							<a-tag color="#cd201f" v-else-if="d.huiyi_status == -1">
								<template #icon>
									<FieldTimeOutlined />
								</template>
								已结束
							</a-tag>

							<div>
								<span style="color: #999; font-size: 13px">{{ d.会议开始时间 }}</span>
								<span style="color: #999; font-size: 13px">~</span>
								<span style="color: #999; font-size: 13px">{{ d.会议结束时间 }}</span>
							</div>

							<div>
								<span style="color: #999; font-size: 13px">{{ d.详细地址 }}</span>
							</div>
						</div>
					</div>
				</a-card>
			</div>
			<div style="padding: 10px; text-align: center">
				<a-image height="150px" width="150px" :src="accountInfo.obj.show_on_mobile_link_img"></a-image>
				<!-- <a-button type="primary" @click="editEvent(d)">查看</a-button> -->
			</div>
			<a-card hoverable :body-style="{ padding: '10px' }">
				<div style="width: 300px; max-height: 800px; overflow-y: auto; background: rgb(247, 249, 250)">
					<div>
						<img style="border-radius: 10px; width: 100%; height: 150px" :src="show_event_head_img" />
					</div>
					<div style="padding: 10px"><span style="font-weight: bold">更多会议</span></div>
					<div style="background-color: #fff; margin: 10px; border-radius: 10px" v-for="(d, index) in showDataList.obj" :key="index">
						<div style="display: flex; padding: 10px">
							<img style="margin-right: 10px; width: 120px; height: 100px; border-radius: 10px" :src="d.huiyi_img ? d.huiyi_img : defaultImg" />
							<div>
								<div style="margin-bottom: 10px">
									<span style="font-weight: bold">{{ d.huiyi_name }}</span>
								</div>

								<div>
									<span style="color: #999; font-size: 12px">{{ d.addr }}</span>
								</div>

								<div style="margin-bottom: 10px">
									<span style="color: #999; font-size: 12px">{{ d.bg_dtme }}</span>
									<span style="color: #999; font-size: 12px">~</span>
									<span style="color: #999; font-size: 12px">{{ d.end_dtme }}</span>
								</div>
							</div>
						</div>
						<!--
						<div style="display: flex; padding: 10px; align-items: center">
							<img style="margin-right: 10px; width: 100px; height: 180px; border-radius: 10px" :src="d.img ? d.img : defaultImg" />
							<div>
								<div style="margin-bottom: 10px">
									<span style="font-weight: bold">{{ d.web_name }}</span>
								</div>

								<div style="margin-bottom: 10px">
									<span style="color: #999; font-size: 12px">{{ d.create_dtme }}</span>
									<span style="color: #999; font-size: 12px">~</span>
									<span style="color: #999; font-size: 12px">{{ d.create_dtme }}</span>
								</div>
							</div>
						</div>-->
					</div>
				</div>
			</a-card>
		</div>
	</div>
</template>

<script setup>
import { ref, onMounted, reactive, h } from 'vue';
import { useRouter } from 'vue-router';
const router = useRouter();
import { myMixin } from './../mixin.js';
const { errorMsgBox, successMsgBox, doConfirm, apiAll, withLoading } = myMixin();
import { PlusOutlined, SearchOutlined, DeleteOutlined, CloseOutlined, EyeOutlined, EditOutlined } from '@ant-design/icons-vue';
const dataList = reactive({ obj: [] });
const showDataList = reactive({ obj: [] });
const page = reactive({ pageSize: 6, startPage: 1, totalResult: 0 });
const defaultImg = require('../assets/defaultImg.png');
const defaultHeadImg = require('../assets/defaultHead.jpg');
const show_event_head_img = ref('');
//accountInfo.obj.show_on_mobile_link_img
const accountInfo = reactive({ obj: {} });
const common_set_json = reactive({ obj: {} });
onMounted(() => {
	getData();
	getMyShowEvent();
	if (window.localStorage.kaola_accountInfo) {
		accountInfo.obj = JSON.parse(window.localStorage.kaola_accountInfo);
		//getAllWebByShowEvent(accountInfo.obj.id);
	}
});
const getMyShowEvent = async () => {
	let data = {};
	let params = {};
	data.params = JSON.stringify(params);
	const res = await withLoading(apiAll(data, '/getMyShowEvent'));
	if (res.code >= 0) {
		common_set_json.obj = res.extra.common_set_json;
		if (common_set_json.obj && common_set_json.obj.show_event_head_img) {
			show_event_head_img.value = common_set_json.obj.show_event_head_img;
		} else {
			show_event_head_img.value = defaultHeadImg;
		}
		showDataList.obj = res.extra.data;
	} else {
		errorMsgBox(res.message);
	}
};
// 保留
// async function getAllWebByShowEvent(accountId) {
// 	let data = {};
// 	let params = {};
// 	params.ephemeralParam = accountId;
// 	data.params = JSON.stringify(params);
// 	const res = await withLoading(apiAll(data, '/getAllWebByShowEvent'));
// 	if (res.code >= 0) {
// 		showDataList.obj = res.extra;
// 	} else {
// 		errorMsgBox(res.message);
// 	}
// }
async function getData() {
	let data = {};
	let params = {};
	params.page = page;
	data.params = JSON.stringify(params);
	const res = await withLoading(apiAll(data, '/getMyEvent'));
	if (res.code >= 0) {
		dataList.obj = res.extra.result;
		// doingHuiyi.value = res.extra.doingHuiyiCount ? res.extra.doingHuiyiCount : 0;
		// finishHuiyi.value = res.extra.finishHuiyiCount ? res.extra.finishHuiyiCount : 0;
		// weekHuiyi.value = res.extra.weekHuiyiCount ? res.extra.weekHuiyiCount : 0;
		// monHuiyi.value = res.extra.monHuiyiCount ? res.extra.monHuiyiCount : 0;
		page.totalResult = res.page.totalResult;
	} else {
		errorMsgBox(res.message);
	}
} //进入活动
const gotoEvent = (d) => {
	sessionStorage.clear();
	window.sessionStorage.setItem('huiyiName', d.会议名称);
	window.open('https://koalahuiyi.com/eventManager?thirdCode=' + d.huiyi_code);
};
const showEvent = (d) => {
	successMsgBox('显示成功');
	handleEventShow(d, 1);
};
const closeEvent = (d) => {
	successMsgBox('关闭成功');
	handleEventShow(d, 0);
};

const handleEventShow = async (d, type) => {
	let data = {};
	let params = {};
	params.ephemeralParam = d.huiyi_code;
	params.ephemeralParam1 = type;
	data.params = JSON.stringify(params);
	const res = await withLoading(apiAll(data, '/handleEventShow'));
	if (res.code >= 0) {
		d.show_on_mobile = type;
		getMyShowEvent();
	} else {
		errorMsgBox(res.message);
	}
};
</script>

<style></style>
